import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import DividerSection from '@segment/templates/DividerSection'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import Companies from './components/Companies'
import EmbraceGoodData from './components/EmbraceGoodData'
import GetStarted from './components/GetStarted'

import CtaSection from './components/CtaSection'

import ogImagePng from './assets/OgGoodData.png'

const GoodDataView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Everything is Better with Good Data | Twilio Segment"
        pageDescription="Segment helps every team access good data. Data that's real-time, clean, and accurate. The result? Relevant customer experiences that drive real revenue."
        pageOG={ogImagePng}
        themeColor={theme.palette.brand.darkAcai[700]}
      >
        <Navigation />
        <AppearanceProvider appearance="twilioDark">
          <Hero />
        </AppearanceProvider>
        <Main>
          <Companies />
          <DividerSection />
          <EmbraceGoodData />
          <GetStarted />
          <CtaSection />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main``

export default GoodDataView
